/* src/app/private/modules/leads/leads.component.scss */
.tab-container {
  display: flex;
  gap: 15px;
  overflow-x: auto;
}
.tab-container::-webkit-scrollbar {
  display: none;
}
.tab {
  padding: 11px 20px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid #FFFFFF;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2509803922) inset;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  font-weight: 600;
  border-bottom-width: 0px !important;
  height: 100%;
}
.outer-tab {
  border: 1px solid #FFFFFF;
  border-width: 1px 1px 1px 0px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  border-bottom-width: 0px !important;
}
.active {
  border-width: 1px 1px 1px 5px;
  border-style: solid;
  border-color: #F0950C;
  font-weight: bold;
  box-shadow: none !important;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
.add-lead-space-outer {
  background-color: var(--primary-color);
  height: 30px;
  width: 30px;
  margin-top: 4px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.add-lead-space-inner {
  background-color: #fff;
  height: 19px;
  width: 19px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-lead-space {
  color: var(--primary-color);
  font-size: 11px;
  font-weight: 700;
}
.create-new-grp-header {
  background-color: var(--primary-color);
  color: #fff;
  padding: 14px 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  position: relative;
}
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
::ng-deep .custom-confirm-dialog.p-dialog {
  max-width: 60vw !important;
  width: 60vw !important;
  border-radius: 1rem !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  overflow: visible !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content {
  padding: 0 !important;
  background: transparent !important;
  overflow: visible !important;
  border-radius: 1rem !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-header {
  display: none !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-footer {
  display: none !important;
}
@keyframes bounce-in {
  0% {
    transform: scale(0) translateY(20px);
    opacity: 0;
  }
  50% {
    transform: scale(1.1) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
::ng-deep .animate-bounce-in {
  animation: bounce-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
/*# sourceMappingURL=leads.component.css.map */
